/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetRewardsRequest} from '@cash-web/protos/squareup/franklin/app/rewards.pb'
import {GetRewardsResponse} from '@cash-web/protos/squareup/franklin/app/rewards.pb'


export const getRewards = (request: GetRewardsRequest, options?: CashRequestOptions) => post<GetRewardsRequest, GetRewardsResponse>("/2.0/cash/get-rewards", request, {...options, rejectOnError: true })